import React from 'react';

import { useGraphWithCredential } from '@microsoft/teamsfx-react';

import UserInfo from '../interface/UserInfo';
import { Theme, themeQuartz } from 'ag-grid-community';
import { tokens } from '@fluentui/react-components';

interface AppContextProps {
    userInfo: UserInfo | undefined;
    gridTheme: Theme;
};

const AppContext = React.createContext<AppContextProps>(null!);

export function AppProvider({ children }: { children: React.ReactNode }) {
    const [userInfo, setUserInfo] = React.useState<UserInfo | undefined>();

    const gridTheme = themeQuartz.withParams({
        backgroundColor: tokens.colorNeutralBackground1,
        textColor: tokens.colorNeutralForeground1,
        borderColor: tokens.colorNeutralStroke1,
        foregroundColor: tokens.colorNeutralForeground1,
        accentColor: tokens.colorBrandForeground1,
        rowHoverColor: tokens.colorNeutralBackground1Hover,
        rowHeight: tokens.spacingVerticalXXXL,
        headerColumnBorder: true,
        headerColumnResizeHandleColor: tokens.colorTransparentStroke,
        headerBackgroundColor: tokens.colorNeutralBackground1Hover,
        columnBorder: true,
        wrapperBorderRadius: tokens.borderRadiusMedium,
    });

    useGraphWithCredential(async (graph) => {
        const user = await graph.api("/me?$select=id,employeeId,displayName,jobTitle,department").get() as UserInfo;
        const photo = await graph.api("/me/photos/48x48/$value").get();

        setTimeout(() => {
            setUserInfo({
                id: user.id,
                employeeId: user.employeeId,
                displayName: user.displayName,
                jobTitle: user.jobTitle,
                department: user.department,
                photo: photo,
                userPrincipal: user.userPrincipal, 
            });
        }, 1000);
    }, { scope: ["User.Read"] });

    return (
        <AppContext.Provider value={{ userInfo, gridTheme}}>
            {children}
        </AppContext.Provider>
    );
};

export function useAppContext() {
    return React.useContext(AppContext);
};